import { AST } from '../ast';
import { mapExprFR } from './map-expr-fr';

export const renameExprAttribute = (
  expr: AST.ExprFR,
  { from, to }: { from: string; to: string }
): AST.ExprFR =>
  mapExprFR(expr, (x) =>
    x.t === 'attr' && x.name === from ? { ...x, name: to } : x
  );
